function consentCookieName() {
	var appName = document.querySelector('meta[name="app-name"]');
	var name = appName ? appName.getAttribute('content') : '';

	name = String(name || 'cookie')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '_')
		.replace(/^_+|_+$/g, '');

	return (name || 'cookie') + '_consent';
}

var cookieName = consentCookieName();


window.dataLayer = window.dataLayer || [];
if (typeof window.gtag !== 'function') {
	window.gtag = function () { window.dataLayer.push(arguments); };
}
function getConsentCookie(name) {
	var dc = document.cookie;
	var prefix = name + "=";
	var begin = dc.indexOf("; " + prefix);
	if (begin == -1) {
		begin = dc.indexOf(prefix);
		if (begin != 0) return null;
	} else {
		begin += 2;
		var end = document.cookie.indexOf(";", begin);
		if (end == -1) {
			end = dc.length;
		}
	}
	return decodeURIComponent(dc.substring(begin + prefix.length, end));
}

function setConsenstCookie(name, value, exdays, path) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = "expires=" + d.toUTCString();
	document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=" + (path ? path : "/") + ";SameSite=Lax";
}

function checkConsentCookie(name) {

	var isCookieConsent = getConsentCookie(name);
	if (isCookieConsent == null) {
		if (typeof window.ehgumiSetMetaConsent === 'function') {
			window.ehgumiSetMetaConsent(false);
		}
		gtag('consent', 'default', {
			'ad_storage': 'denied',
			'ad_user_data': 'denied',
			'ad_personalization': 'denied',
			'analytics_storage': 'denied',
			'personalization_storage': 'denied',
			'security_storage': 'denied',
			'performance_storage': 'denied',
			'wait_for_update': 500
		});
		$(".cookieconsent-input").each(function () {
			$(this).prop('checked', true);
		});
		bootstrap.Modal.getOrCreateInstance(document.querySelector('.cookieconsent-modal')).show();
	} else {
		var cookieArray;
		try {
			cookieArray = JSON.parse(isCookieConsent.split(';')[0]);
		} catch (e) {
			cookieArray = null;
		}
		if (!Array.isArray(cookieArray)) {
			setConsenstCookie(cookieName, '', -1);
			return checkConsentCookie(cookieName);
		}
		if (typeof window.ehgumiSetMetaConsent === 'function') {
			window.ehgumiSetMetaConsent(cookieArray.includes('ad'));
		}
		gtag('consent', 'default', {
			'ad_storage': (cookieArray.includes('ad')) ? 'granted' : 'denied',
			'ad_user_data': (cookieArray.includes('ad')) ? 'granted' : 'denied',
			'ad_personalization': (cookieArray.includes('ad')) ? 'granted' : 'denied',
			'analytics_storage': (cookieArray.includes('analytics')) ? 'granted' : 'denied',
			'functionality_storage': (cookieArray.includes('function')) ? 'granted' : 'denied',
			'personalization_storage': (cookieArray.includes('function')) ? 'granted' : 'denied',
			'security_storage': (cookieArray.includes('default')) ? 'granted' : 'denied',
			'performance_storage': (cookieArray.includes('performance')) ? 'granted' : 'denied',
			'wait_for_update': 500
		});
		if (cookieArray.length) {
			for (var i = 0; i < cookieArray.length; i++) {
				$('.cookieconsent-input[data-value="' + cookieArray[i] + '"]').prop('checked', true);
			}
		}
	}
}

$(function () {

	$('.showCookiePanel').on('click', function () {
		bootstrap.Modal.getOrCreateInstance(document.querySelector('.cookieconsent-modal')).show();
		$('.showConsentSettings').trigger('click');
	})


	if ($(".cookieconsent-input").length) {
		checkConsentCookie(cookieName);

		$('.showConsentSettings').on('click', function () {
			$('.consentSettings').fadeIn(100);
		});

		$('.saveCookieConsent').on('click', function () {
			var cookieArray = new Array();
			$(".cookieconsent-input").each(function () {
				var value = null;
				if ($(this).is(':checked')) {
					value = $(this).attr('data-value');
					cookieArray.push(value);
				}
			});
			setConsenstCookie(cookieName, JSON.stringify(cookieArray), 356);
			gtag('consent', 'update', {
				'ad_storage': (cookieArray.includes('ad')) ? 'granted' : 'denied',
				'ad_user_data': (cookieArray.includes('ad')) ? 'granted' : 'denied',
				'ad_personalization': (cookieArray.includes('ad')) ? 'granted' : 'denied',
				'analytics_storage': (cookieArray.includes('analytics')) ? 'granted' : 'denied',
				'functionality_storage': (cookieArray.includes('function')) ? 'granted' : 'denied',
				'personalization_storage': (cookieArray.includes('function')) ? 'granted' : 'denied',
				'security_storage': (cookieArray.includes('default')) ? 'granted' : 'denied',
				'performance_storage': (cookieArray.includes('performance')) ? 'granted' : 'denied',
			});

			if (typeof window.ehgumiSetMetaConsent === 'function') {
				window.ehgumiSetMetaConsent(cookieArray.includes('ad'));
			}
			bootstrap.Modal.getOrCreateInstance(document.querySelector('.cookieconsent-modal')).hide();
		});
	}
});
